import GoogleMap from "./gmap/GoogleMap";

export function getNavLink(lat, lon){
    return 'https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=' + lat + ',' + lon;
}

export default (node, callback) => {
    const apiKey = 'AIzaSyC3HqDeFc_ZXICqPxIVXDLz55yErCs4-Tk';
    const id = "gmap_" + Math.round(Math.random() * 1000000).toString();
    const script = document.createElement('script');

    // Register callback globally
    window[id] = () => {
        const map = new GoogleMap(node);
        callback(map);
    };

    // build and inject gMap script
    script.async = true;
    script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=${id}`;
    document.querySelector('head').appendChild(script);
}
